import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'

export default function CompanyTerms() {
 const [companyTerms, setCompanyTerms] = useState('');
  useEffect(() => {
    let comid = localStorage.getItem('mem_company_id');
    loadCompanyTerms(comid)
  }, []);

  const loadCompanyTerms = async (comid) => {
    try {
      const response = await fetch(`getCompanyDetails.php?uuid=${comid}`);
      const result = await response.json();

      if (result.status === "success") {
        prefilldata(result.data);
      } else {
        console.warn("No data found for this UUID");
      }
    } catch (err) {
      console.error("Error loading draft:", err);
    }
  }

  function prefilldata(data) {
    setCompanyTerms(data.company_terms)
    $('#update_date').text(data.terms_update_date)
  }

  function showAlert(msg) {

    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function saveterms() {
    let mem_company_id = localStorage.getItem('mem_company_id');
    const now = new Date();
    const datetoday = now.toLocaleDateString(); // Date only
    const formData = new FormData();
    var comterms = companyTerms;
    console.log(comterms)
    if (comterms === '') {
      showAlert('Please insert the terms and policies.')
    } else {
      formData.append('company_terms', comterms);
      formData.append('com_id', mem_company_id);
      formData.append('terms_update_date', datetoday);
      fetch('updateCompanyTerms.php', {
        method: 'POST',
        body: formData
      })
        .then(res => res.json())
        .then(data => {

          if (data.status === 'success') {
            console.log(data);
            alert("Terms update success");
          } else {
            showAlert(data.message);
          }
        })
        .catch(err => {
          console.error(err);
          showAlert("Terms update failed");
        });
    }

  }
  return (
    <div className="terms-page">
      <div className="terms-container">

        <div className="terms-header">
          <div>
            <h1>Company Terms & Policies</h1>
            <p>Define internal rules and usage policies</p>
          </div>
          <button className="btn-primary" onClick={saveterms}>Save Changes</button>
        </div>

        <div className="cardwide">
          <h2>Purpose</h2>
          <p>
            These terms apply to all members of your organization using this
            project management platform.
          </p>
        </div>

        <div className="cardwide">
          <h2>Custom Company Terms</h2>
          <p className="hint">
            Write your own internal terms and policies.
          </p>

          <textarea className="terms-textarea" id="company_terms" onChange={(e) => setCompanyTerms(e.target.value)} value={companyTerms} placeholder={`Example:
1. Update task status daily
2. Do not share credentials
3. Admin decisions are final`}
          />

          <div className="actions">
            <button className="btn-outline">Cancel</button>
            <button className="btn-primary" onClick={saveterms}>Save Terms</button>
          </div>
        </div>

        <p className="footer-note">
          <span id="update_date"></span>
        </p>

      </div>
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
    </div>
  );
}

